/**
 * @file: 层板商品排列算法
 * @author: xiaolong.huang@dmall.com
 */

import FrontCubeData from '../../frontCubeData/index';
import LeftToRight from './leftToRight';
import RightToLeft from './rightToLeft';
import SpaceAround from './spaceAround';
import SpaceBetween from './spaceBetween';
import LayoutFree from './layoutFree';
import { getCubeNumberValue } from '../func/index';
import { layoutType } from './layerInfo';

export function updateGoodsLayout(cube: CubeNode): void {
    let moduleWidth: number = getCubeNumberValue(cube.id, 'moduleWidth');
    let type: LayoutType = layoutType(cube.id);
    let layoutTask: Array<LayoutTask> = [
        {
            width: moduleWidth,
            layerId: cube.id
        }
    ];

    switch(type) {
        // 从左到右追加
        case '|||---':
            LeftToRight(layoutTask);
            break;

        // 从右到左追加
        case '---|||':
            RightToLeft(layoutTask);
            break;

        // 均匀分布
        case '-|-|-':
            SpaceAround(layoutTask);
            break;

        // 贴边均匀
        case '|-|-|':
            SpaceBetween(layoutTask);
            break;

        // 手动放置
        case '|-|--|---':
            LayoutFree(layoutTask);
            break;

        default:
            break;
    }
}
